import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { countByCategory, getPostsByCategory, toneClasses } from '@/utils/content';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs font-medium text-primary-600 tracking-widest">
              CATEGORIES / 分区浏览
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              分类合集，按你关心的方向看
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            每个分区只放同一主题的内容，点进去就是一条完整的内容线，不用在杂乱的列表里反复筛选。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => {
            const count = countByCategory(category.slug);
            const latest = getPostsByCategory(category.slug)[0];
            const tone = toneClasses[category.tone];
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`w-12 h-12 rounded-md flex items-center justify-center ${tone.soft}`}
                  >
                    <i className={`${category.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs text-foreground-500">{count} 篇话题</span>
                </div>

                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {category.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {category.description}
                </p>

                {latest && (
                  <div className="mt-4 pt-3 border-t border-background-100 text-xs text-foreground-500 flex items-start gap-2">
                    <i className={`ri-arrow-right-s-line ${tone.text} mt-0.5`}></i>
                    <span className="line-clamp-1">最新：{latest.title}</span>
                  </div>
                )}

                <span className={`mt-4 inline-flex items-center gap-1 text-sm font-medium ${tone.text}`}>
                  浏览该合集
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </Link>
            );
          })}

          <div className="flex flex-col justify-center rounded-lg border border-dashed border-background-300 bg-background-100 p-6">
            <span className="w-12 h-12 rounded-md bg-background-50 border border-background-300 flex items-center justify-center text-foreground-700">
              <i className="ri-add-line text-xl"></i>
            </span>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">
              想看的分类还没有？
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              告诉我们你希望新增哪个方向的分区，编辑团队会评估后补充合集。
            </p>
            <Link
              to="/about#contact"
              className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
            >
              提交分类建议
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}